import type { ParsedContactQr } from '@/utils/parseContactQrPayload'

export type QrLeadScanResult = {
  nome?: string
  telefone?: string
  source?: ParsedContactQr['source']
}

export type QrLeadScanHints = {
  highlightContato: boolean
  highlightEmpresa: boolean
  whatsappOnlyPhone: boolean
}

export function getQrLeadScanHints(result: QrLeadScanResult): QrLeadScanHints {
  const hasPhone = Boolean(result.telefone)
  const hasName = Boolean(result.nome?.trim())
  const whatsappSource =
    result.source === 'wa_me' || result.source === 'whatsapp_api' || result.source === 'phone_digits'

  return {
    highlightContato: hasPhone && !hasName,
    highlightEmpresa: hasPhone,
    whatsappOnlyPhone: whatsappSource && hasPhone && !hasName,
  }
}

export function qrLeadScanToastMessage(hints: QrLeadScanHints): string {
  if (hints.whatsappOnlyPhone) {
    return 'Telefone lido do WhatsApp. Preencha o nome e a empresa.'
  }
  if (hints.highlightContato) {
    return 'Complete o nome do contato e a empresa.'
  }
  if (hints.highlightEmpresa) {
    return 'Contato identificado. Informe a empresa para cadastrar.'
  }
  return 'QR lido com sucesso.'
}
